import type { IToken } from 'chevrotain';

export const getTokenName = (token: IToken) =>
  token.tokenType ? token.tokenType.name : /* istanbul ignore next */ '';
